export default __webpack_public_path__ + "static/media/logo.533206c3.jpg";